import { fetchUserInfo } from "@/api/user";
import { TUserInfo } from "@/typings";
import { getUserInfo } from "@/utils/get-app-info";
import { create } from "zustand";

interface UserStore {
  loading?: boolean;
  userInfo?: TUserInfo;
  fetchUserInfo: () => void;
}

const useUserStore = create<UserStore>((set) => ({
  loading: false,
  userInfo: undefined,
  fetchUserInfo: async () => {
    set({ loading: true });
    const userInfo = await getUserInfo();

    if (userInfo) {
      set({ userInfo });
      set({ loading: false });
      return;
    }
    try {
      const userInfo = await fetchUserInfo();

      set({ loading: false });
      if (userInfo) {
        set({ userInfo: userInfo?.data });
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      set({ loading: false, userInfo: undefined });
    }
  },
}));

export { useUserStore };
